<form
  #form="ngForm"
  novalidate
>
  <p-divider></p-divider>
  <div class="mb-4 flex flex-col gap-1">
    <p class="pb-2 font-semibold">Totals</p>
    @for (
      total of object.entries(stockStore.vm().inUseTankTotals);
      track total[0]
    ) {
      <div class="flex items-center justify-between gap-4">
        <p class="text-sm font-semibold">
          {{ total[0] }}
          @if (total[1].currentMT > 205) {
            <nsp-icon
              [name]="IconNames.ExclamationTriangle"
              [size]="'sm'"
              class="text-orange-400"
            />
          }
        </p>
        <p class="text-sm font-semibold">{{ total[1].currentMT }} MT/200MT</p>
      </div>
    }
  </div>
  <p-divider> </p-divider>
  <p class="pb-2 font-semibold">Tanks</p>

  @for (item of stockStore.vm().inUseTanks; track item.id; let i = $index) {
    <div class="mb-4 flex items-center justify-between gap-4">
      <div class="flex flex-col gap-1">
        <p class="text-sm font-semibold text-nowrap">
          {{ item.tankName.value }}
        </p>
        <p class="text-xs text-nowrap text-gray-500">
          {{ item.fuelGrade.value?.name }}
        </p>
      </div>
      <div>
        <nsp-number-input
          [id]="`tankRows-amount-${item['index'].value ?? i}`"
          [name]="`tankRows-amount-${item['index'].value ?? i}`"
          [required]="true"
          [min]="0"
          [value]="item.amount.value"
          [ngModel]="item.amount.value"
        />
      </div>
    </div>
  }
  <p-divider></p-divider>
</form>
